import {
  getApiActionReducers,
  STATUS,
} from '@binotel-frontend/bnt-common-components';
import {createFeature, createReducer, on} from '@ngrx/store';

import {HistoryActions} from './history.actions';
import {IHistoryState} from './history-state.interface';

const historyFeatureKey = 'historyFeature';

const initialState: IHistoryState = {
  history: [],
  historyLoadingStatus: STATUS.default,
};

const historyReducer = createReducer(
  initialState,
  ...getApiActionReducers<IHistoryState>()(
    HistoryActions.getHistory,
    'history'
  ),
  on(HistoryActions.clearHistory, (): IHistoryState => initialState)
);

export const historyFeature = createFeature({
  name: historyFeatureKey,
  reducer: historyReducer,
});
